import Immutable from "seamless-immutable";

const initialState = Immutable({});

const InvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default InvoicesReducer;
